<template>
  <div class="page-card membership-page">
    <div class="page-head">
      <h2 class="page-title">会员管理中心</h2>
      <el-button type="primary" @click="fetchData">刷新</el-button>
    </div>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>会员价格设置</span>
      </div>
      <el-table :data="plans" border>
        <el-table-column label="会员等级" width="120">
          <template slot-scope="{ row }">{{ levelText(row.membershipLevel) }}</template>
        </el-table-column>
        <el-table-column label="周期" width="100">
          <template slot-scope="{ row }">{{ periodText(row.periodType) }}</template>
        </el-table-column>
        <el-table-column prop="planName" label="套餐名称" min-width="160" />
        <el-table-column prop="salePrice" label="售价" width="120" />
        <el-table-column prop="originalPrice" label="划线价" width="120" />
        <el-table-column prop="grantExposureValue" label="赠送曝光值" width="120" />
        <el-table-column label="推荐" width="90">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.recommendFlag === 1 ? 'success' : 'info'">
              {{ row.recommendFlag === 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.planStatus === 1 ? 'success' : 'info'">
              {{ row.planStatus === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column label="操作" width="90">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openPlanDialog(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>权益对比编辑</span>
        <el-button type="primary" size="small" @click="openBenefitDialog()">新增权益</el-button>
      </div>
      <el-table :data="benefits" border>
        <el-table-column prop="benefitName" label="权益名称" min-width="150" />
        <el-table-column prop="iconType" label="图标" width="100" />
        <el-table-column prop="normalText" label="普通" min-width="120" />
        <el-table-column prop="basicText" label="核心用户" min-width="120" />
        <el-table-column prop="premiumText" label="联合发起人" min-width="120" />
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.benefitStatus === 1 ? 'success' : 'info'">
              {{ row.benefitStatus === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortNo" label="排序" width="80" />
        <el-table-column label="操作" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openBenefitDialog(row)">编辑</el-button>
            <el-button type="text" class="danger-link" @click="removeBenefit(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="编辑套餐" :visible.sync="planDialogVisible" width="520px">
      <el-form :model="planForm" label-width="96px">
        <el-form-item label="套餐名称">
          <el-input v-model="planForm.planName" />
        </el-form-item>
        <el-form-item label="售价">
          <el-input-number v-model="planForm.salePrice" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="划线价">
          <el-input-number v-model="planForm.originalPrice" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="赠送曝光值">
          <el-input-number v-model="planForm.grantExposureValue" :min="0" :precision="0" />
        </el-form-item>
        <el-form-item label="推荐">
          <el-switch v-model="planForm.recommendFlag" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="planForm.planStatus" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="planForm.sortNo" :min="0" :precision="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="planForm.remark" type="textarea" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="planDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="savePlanForm">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="benefitForm.id ? '编辑权益' : '新增权益'" :visible.sync="benefitDialogVisible" width="620px">
      <el-form :model="benefitForm" label-width="110px">
        <el-form-item label="权益编码" v-if="!benefitForm.id">
          <el-input v-model="benefitForm.benefitCode" placeholder="不填则自动生成" />
        </el-form-item>
        <el-form-item label="权益名称">
          <el-input v-model="benefitForm.benefitName" />
        </el-form-item>
        <el-form-item label="图标类型">
          <el-select v-model="benefitForm.iconType" clearable placeholder="请选择">
            <el-option label="私信" value="message" />
            <el-option label="筛选" value="filter" />
            <el-option label="推荐" value="trend" />
            <el-option label="标识" value="badge" />
            <el-option label="模板" value="template" />
            <el-option label="佣金" value="commission" />
            <el-option label="账号" value="account" />
          </el-select>
        </el-form-item>
        <el-form-item label="普通展示">
          <el-input v-model="benefitForm.normalText" />
        </el-form-item>
        <el-form-item label="核心用户展示">
          <el-input v-model="benefitForm.basicText" />
        </el-form-item>
        <el-form-item label="联合发起人展示">
          <el-input v-model="benefitForm.premiumText" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="benefitForm.benefitStatus" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="benefitForm.sortNo" :min="0" :precision="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="benefitForm.remark" type="textarea" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="benefitDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBenefitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { membershipLevelLabel } from '../../../utils/format'
import {
  createMembershipBenefit,
  deleteMembershipBenefit,
  getMembershipBenefits,
  getMembershipPlans,
  saveMembershipBenefit,
  saveMembershipPlan
} from '../../../api/platformManage'

export default {
  name: 'MembershipManagePage',
  data() {
    return {
      plans: [],
      benefits: [],
      planDialogVisible: false,
      benefitDialogVisible: false,
      planForm: {},
      benefitForm: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const [plans, benefits] = await Promise.all([
        getMembershipPlans(),
        getMembershipBenefits()
      ])
      this.plans = Array.isArray(plans) ? plans : []
      this.benefits = Array.isArray(benefits) ? benefits : []
    },
    levelText(value) {
      return membershipLevelLabel(value, '核心用户')
    },
    periodText(value) {
      if (value === 2) return '年卡'
      if (value === 3) return '永久'
      return '月卡'
    },
    openPlanDialog(row) {
      this.planForm = { ...row }
      this.planDialogVisible = true
    },
    async savePlanForm() {
      await saveMembershipPlan(this.planForm.id, this.planForm)
      this.$message.success('套餐保存成功')
      this.planDialogVisible = false
      await this.fetchData()
    },
    openBenefitDialog(row) {
      this.benefitForm = row ? { ...row } : {
        benefitCode: '',
        benefitName: '',
        iconType: '',
        normalText: '-',
        basicText: '-',
        premiumText: '-',
        benefitStatus: 1,
        sortNo: 0,
        remark: ''
      }
      this.benefitDialogVisible = true
    },
    async saveBenefitForm() {
      if (this.benefitForm.id) {
        await saveMembershipBenefit(this.benefitForm.id, this.benefitForm)
      } else {
        await createMembershipBenefit(this.benefitForm)
      }
      this.$message.success('权益保存成功')
      this.benefitDialogVisible = false
      await this.fetchData()
    },
    async removeBenefit(row) {
      try {
        await MessageBox.confirm(`确认删除权益“${row.benefitName}”吗？`, '删除确认', {
          type: 'warning',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }
      await deleteMembershipBenefit(row.id)
      this.$message.success('删除成功')
      await this.fetchData()
    }
  }
}
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-card {
  margin-top: 18px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.danger-link {
  color: #f56c6c;
}
</style>
